<template>

    <div class="py-smart-form-debug">
        <span class="py-sf-close-debug" @click="closeDebug">close</span>
        <span class="py-sf-label">SmartForm Insights</span>
        <div :style="styleObject">
            <div class="sf-db-section" style="display: none">
                <div class="sf-db-heading">State</div>
                <div class="sf-db-data">
                    <table>
                        <tr v-for="(formEl, key) in formData.state">
                            <td class="title" :title="key">{{ key }}</td>
                            <td>{{ formEl }}</td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="sf-db-section">
                <div class="sf-db-heading">Settings</div>
                <div class="sf-db-data">
                    <table>
                        <tr>
                            <td class="title">version</td>
                            <td><span>{{ formData.version }}</span></td>
                        </tr>
                        <tr>
                            <td class="title">template</td>
                            <td><span>{{ formData.config.template }}</span></td>
                        </tr>
                        <tr>
                            <td class="title">language</td>
                            <td><span>{{ language }}</span></td>
                        </tr>
                        <tr>
                            <td class="title">GA Host</td>
                            <td><span>{{ formData.config.ga_host }}</span></td>
                        </tr>
                        <tr>
                            <td class="title">endpoint</td>
                            <td v-on:click="toggleField"><input type="text" v-on:blur="saveEdit" v-model="formData.endpoint" /><span>{{ formData.endpoint }}</span></td>
                        </tr>
                        <tr>
                            <td class="title">redirect</td>
                            <td v-on:click="toggleField"><input type="text" v-on:blur="saveEdit" v-model="formData.config.redirect" /><span>{{ formData.config.redirect }}</span></td>
                        </tr>
                        <tr v-for="(formEl, key) in formData.settings">
                            <td class="title" :title="key">{{ key }}</td>
                            <td>{{ formEl }}</td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="sf-db-section">
                <div class="sf-db-heading">Google Analytics</div>
                <div class="sf-db-data">
                    <table>
                        <tr v-for="(formEl, key) in formData.ga">
                            <td class="title" :title="key">{{ key }}</td>
                            <td>{{ formEl }}</td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="sf-db-section">
                <div class="sf-db-heading">Form Data</div>
                <div class="sf-db-data">
                    <table>
                        <tr>
                            <td><span class="title"></span></td>
                            <td><span><strong>Live</strong></span></td>
                            <td><span><strong>Prefilled</strong></span></td>
                        </tr>
                        <tr v-for="(formEl, key) in formData.fields">
                            <td><span class="title" :title="key">{{ key }}</span></td>
                            <td v-on:click="toggleField"><input type="text" v-on:blur="saveEdit" v-model="formData.fields[key]" /><span>{{ formEl }}</span></td>
                            <td><span>{{ formData.prefill[key] }}</span></td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="sf-db-section" style="display: none;">
                <div class="sf-db-heading">Form Data</div>
                <div class="sf-db-data">
                    <table>
                        <tr v-for="(formEl, key) in formData.prefill">
                            <td><span class="title" :title="key">{{ key }}</span></td>
                            <td><span>{{ formEl }}</span></td>
                        </tr>
                    </table>
                </div>
            </div>

        </div>
    </div>


</template>

<script>

    export default {
        name: 'smart-form-debug',
        props: {
            formData: {
                type: Object
            }
        },
        data(){
            return {
                styleObject: {
                    height: (window.innerHeight-130)+"px"
                },
                language: this.$i18n.locale
            }
        },
        methods:{
            toggleField(el){
                var td = (el.target.localName === "td") ? el.target : el.target.parentElement
                td.className = "editMode"
                td.firstChild.focus()
            },
            saveEdit(el){
                el.target.parentElement.className = ""
            },
            closeDebug(){
                this.$parent.$emit("closeDebug")
            }
        }

    }
</script>

<style lang="scss">
    $ctx-teal-50: #05758a;
    .smart-form {
        .py-smart-form-debug {
            position: fixed;
            height: 100%;
            width: 500px;
            right: 0;
            top: 0;
            border-top: 10px solid $ctx-teal-50;
            box-shadow: 5px 8px 0 10px rgba(0, 0, 0, 0.1);
            padding: 20px;
            background-color: #fff;
            z-index: 9999;

            table {
                width: 100%;
                border-collapse: collapse;

                tr {
                    &:nth-child(even) {
                        background-color: #f0f7ff;
                    }
                }

                td {
                    font-size: 12px;
                    padding: 3px;
                    
                    &.editMode {
                        input {
                            display: block
                        }
                        span{
                            display: none;
                        }
                    }
                }

                td:nth-child(1) {
                    font-weight: bold;
                    text-align: left;
                    width: 100px;
                    padding-right: 15px;
                    padding-left: 8px
                }

                td:nth-child(2),
                td:nth-child(3) {
                    width: 150px;
                    padding-right: 10px
                }
                input{
                    border: 1px solid #555;
                    background-color: #fff;
                    width: 100%;
                    display: none;
                    padding: 5px;
                }
            }

            & > div {
                overflow: scroll;
                height: 100%;
                padding-bottom: 100px;
                margin-top: 20px
            }

            .sf-db-section {

                padding-bottom: 25px;

                .sf-db-heading {
                    font-weight: bold;
                    border-bottom: 2px solid $ctx-teal-50;
                    color: $ctx-teal-50;
                    padding: 3px 5px

                }
            }

            .py-sf-close-debug{
                display: block;
                position: absolute;
                right: 20px;
                top: 15px;
                border-radius: 50px;
                border: 1px solid $ctx-teal-50;
                height: 30px;
                padding: 0 20px;
                line-height: 30px;
                text-align: center;
                font-size: 12px;
                color: $ctx-teal-50;

                &:hover{
                    background-color: $ctx-teal-50;
                    color: #fff;
                    cursor: pointer;
                }
            }

            span {
                font-weight: normal;
                font-size: 12px;
                position: relative;
                display: inline-block;

                &.title {
                    font-weight: bold;
                    width: 140px;
                    text-align: right;
                    font-size: 10px;
                    padding-left: 5px;
                    cursor: help;
                    top: 2px;
                    word-wrap: break-word;
                    line-height: 14px;
                    position: relative;
                    top: -1px

                }

                &:nth-child(3) {
                    font-size: 0.7rem
                }

                &.py-sf-label {
                    font-size: 26px;
                }
            }


        }
    }

</style>